import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface MonthlyTrendPoint {
  month: string;
  registrations: number;
  completed: number;
  selected: number;
  joined: number;
}

interface MonthlyHiringTrendProps {
  data: MonthlyTrendPoint[];
}

export function MonthlyHiringTrend({ data }: MonthlyHiringTrendProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Monthly Hiring Trends</CardTitle>
        <CardDescription>
          Registration, completion, selection, and joining movement across the selected year
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="registrations" name="Registrations" fill="#2563eb" radius={[4, 4, 0, 0]} />
            <Bar dataKey="completed" name="Completed" fill="#14B8A6" radius={[4, 4, 0, 0]} />
            <Bar dataKey="selected" name="Selected" fill="#F59E0B" radius={[4, 4, 0, 0]} />
            <Bar dataKey="joined" name="Joined" fill="#334155" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
